import React from 'react';
import { TextField, MenuItem, Box, Typography, Grid } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'rpad',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: '',
      pad_len: 10,
      transformInPlace: false,
    },
  ],
};
const validationSchema = {
  ...COMMON_VALIDATION,
  'transformations.param': {
    validate: (value) => {
      if (!value || !value.trim()) {
        return 'Pad Character is required';
      }
      return '';
    },
  },
  'transformations.pad_len': {
    validate: (value) => {
      if (!value) {
        return 'Pad Length is required';
      }
      return '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CheckBoxField
            checked={transform.transformInPlace}
            onChange={(value) => handleInPlaceChange(index, value)}
            disabled={disableForm}
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <SourceColumnField
            value={transform.sourceColumns[0] || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].sourceColumns = [e.target.value];
              setFieldValue('transformations', newTransforms);
            }}
            headers={headers}
            disabled={disableForm}
            error={!!errors?.sourceColumns}
            helperText={
              errors?.sourceColumns ||
              (transform.transformInPlace ? 'This column will be modified directly' : 'Select text column')
            }
          />
        </Grid>
        {!transform.transformInPlace && (
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.outputColumn || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].outputColumn = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors?.outputColumn}
              helperText={errors?.outputColumn || 'Enter output column name'}
            />
          </Grid>
        )}
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.param}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].param = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            label="Pad Character *"
            helperText={errors?.param || 'Character to add to complete pad length'}
            error={!!errors?.param}
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <TextField
            fullWidth
            label="Total Length *"
            type="number"
            size="small"
            disabled={disableForm}
            value={transform.pad_len}
            helperText={errors?.pad_len || 'pad length'}
            error={!!errors?.pad_len}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].pad_len = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            inputProps={{ min: 1 }}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title='Pad Right - Add leading characters ("5", length = 3 , character = "0" → "500")' disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_Rpad = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Pad Right"
  />
);

export default NodeModal_Rpad;
